import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  createAdmin(payload) {
    return api.post(`/admins`, { admin: payload });
  },
  listAdmin(limit = '20', status) {
    const params = {
      limit,
      status,
    };
    const url = '/admins';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  updateAdmin(id, payload) {
    return api.put(`/admins/${id}`, { admin: payload });
  },
  changeAdminPassword(payload) {
    return api.post(`/admins/change_password`, payload);
  },
  deactivateAdmin(id) {
    return api.delete(`/admins/${id}`);
  },
  deleteAdmin(id) {
    return api.delete(`/admins/${id}/delete`);
  },
  restoreAdmin(id) {
    return api.put(`/admins/${id}/reactivate`);
  },
  getAdmin(id) {
    return api.get(`/admins/${id}`);
  },
  getAdminMe() {
    return api.get(`/admins/me`);
  },
  getRoles(page, q = '', limit = 10) {
    const params = {
      cursor: page,
      q,
      limit,
      status: 'active',
    };
    const url = '/admins/roles';
    return api.get(url, { params: omitBy(params, isNil) });
  },
};
